<template>
    <div class="revision-process">
        <div class="con main">
            <el-container>
                <el-main>
                    <p style="margin-bottom:15px">主要流程</p>
                    <el-timeline>
                        <template v-for="(item,index) in mainNodeList">
                            <el-row class="mainElrow" :key="index">
                                <el-col :span="7" style="text-align:right" v-if="item.child.length>0">
                                    <span style="color:#ab6bbd;padding-right:10px">{{item.nodename}}</span>
                                </el-col>
                                <el-col :span="17">
                                    <template v-for="(li, indexIn) in item.child">
                                        <el-row v-if="li.nodetype=='1'" :key="indexIn">
                                            <el-col :span="20">
                                                <el-timeline-item
                                                    v-if="li.izdata"
                                                    type="primary"
                                                    size="large">
                                                        <el-link 
                                                           :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                            @click="nodeclick(li)"
                                                            :underline="false">
                                                                {{li.nodename}}
                                                        </el-link>
                                                </el-timeline-item>
                                                <el-timeline-item
                                                    v-if="!li.izdata"
                                                    size="large">
                                                        <el-link 
                                                            :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                            @click="nodeclick(li)"
                                                            :underline="false">
                                                                {{li.nodename}}
                                                        </el-link>
                                                </el-timeline-item>
                                            </el-col>
                                            <!--
                                            <el-col :span="4">
                                                <i 
                                                    v-if="li.addurl"
                                                    style="color:#ab6bbd;font-size:16px;cursor: pointer;" 
                                                    class="el-icon-circle-plus"
                                                    @click="$emit('nodeAdd',li)">
                                                </i>
                                            </el-col>-->
                                        </el-row>
                                        
                                    </template>
                                </el-col>
                                
                            </el-row>
                        </template>
                        
                    </el-timeline>
                </el-main>
            </el-container>
            
        </div>
        <div class="con main other-flow">
            <el-container>
                
                <el-main>
                    <p style="margin-bottom:15px">附加流程</p>
                    <el-timeline>
                        <template v-for="(item,index) in subNodeList">
                            <el-row class="subElrow" :key="index">
                                <el-col :span="7" style="text-align:right" v-if="item.child.length>0">
                                    <span style="color:#ab6bbd;padding-right:10px">{{item.nodename}}</span>
                                </el-col>
                                <el-col :span="17">
                                    <template v-for="(li, indexIn) in item.child">
                                        <el-timeline-item
                                            :key="indexIn"
                                            v-if="li.nodetype=='2'&&li.izdata"
                                            type="primary"
                                            size="large">
                                                <el-link 
                                                    :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                    @click="nodeclick(li)"
                                                    :underline="false">
                                                        <el-badge 
                                                            is-dot 
                                                            v-if="(li.nodecode=='B07001'&&isInfo.izTbCqWt)||(li.nodecode=='E07001'&&isInfo.izZjCqWt)||(li.nodecode=='F11001'&&isInfo.izZbYyTs)"
                                                            class="item">
                                                                {{li.nodename}}
                                                        </el-badge>
                                                        <span v-else>{{li.nodename}}</span>
                                                </el-link>
                                        </el-timeline-item>
                                        <el-timeline-item
                                            :key="indexIn"
                                            v-if="li.nodetype=='2'&&!li.izdata"
                                            size="large">
                                                <el-link 
                                                    :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                    @click="nodeclick(li)"
                                                    :underline="false">
                                                        <el-badge 
                                                            is-dot 
                                                            v-if="(li.nodecode=='B07001'&&isInfo.izTbCqWt)||(li.nodecode=='E07001'&&isInfo.izZjCqWt)||(li.nodecode=='F11001'&&isInfo.izZbYyTs)"
                                                            class="item">
                                                                {{li.nodename}}
                                                        </el-badge>
                                                        <span v-else>{{li.nodename}}</span>
                                                </el-link>
                                        </el-timeline-item>
                                    </template>
                                </el-col>
                            </el-row>
                        </template>
                        
                    </el-timeline>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        model: {
            type: Object,
            default: () => ({})
        },
        isInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            mainNodeList:[],
            subNodeList:[],
            clickpath:'',
        }
    },
    watch: {
        model:function(data){
            
            
        }
    },
    methods: {
        nodeclick(li){
            this.$emit('nodeClick',li);
            this.clickpath = li.nodeurl+li.nodename;
        },
        init(data){
            var that = this;
            that.mainNodeList = clone(data.nodeList);
            that.subNodeList = clone(data.nodeList);
            data.nodeList.forEach(function(item,index){
                that.mainNodeList[index].child = [];
                that.subNodeList[index].child = [];
                if(!!item.child){
                    item.child.forEach(function(list,i){
                        if(list.nodetype=='1'){
                            that.mainNodeList[index].child.push(list)
                        }else if(list.nodetype=='2'){
                            that.subNodeList[index].child.push(list)
                        }
                    })
                }
            })
        },
        processClick(url){
            this.$emit('goFrame',url)
        },
       
    },
    mounted(){
        this.clickpath = '/bidding/projectflow/fangan/biaoduan/list';
    },
}
</script>

<style scoped>
    .con{ overflow: hidden;}
    .mainElrow:last-child /deep/ .el-col .el-row:last-child .el-timeline-item .el-timeline-item__tail{ display: none; }
    .subElrow:last-child /deep/ .el-col .el-timeline-item:last-child .el-timeline-item__tail{ display: none; }
    .other-flow .el-aside{overflow: hidden;}
</style>